export const EFFECTS_PER_BLOCK_LIMIT = 20;
export const CONDITIONAL_EFFECT_MAX_LIMIT = 100;
